<template>
  <div class="discounted-main-box">
    <WebHeaderView />
    <DiscountBannerSwipeView :lst="bannerlst" />
    <div class="page-noticebox">
      <van-notice-bar :scrollable="false">
        <van-swipe
          vertical
          :autoplay="3500"
          class="notice-swipe"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) in msglst" :key="index">{{
            item
          }}</van-swipe-item>
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="page-data-box">
      <div class="col-box">
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
      </div>
      <div class="col-box">
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
        <ProLstColItemView />
      </div>
    </div>
  </div>
</template>

<script>
import WebHeaderView from '@/components/header/index.vue'
import { ProLstColItemView, DiscountBannerSwipeView } from './components/index'
export default {
  name: 'DiscountedNewView',
  components: { ProLstColItemView, WebHeaderView, DiscountBannerSwipeView },
  data () {
    return {
      msglst: [],
      bannerlst: [
        {
          img: 'https://img01.yzcdn.cn/vant/apple-1.jpg',
          text: '对应图片的主题的捡漏介绍信息对应图片的主题的捡漏介绍信息对应图片的主题的捡漏介绍信息对应图片的主题的捡漏介绍信息'
        },
        {
          img: 'https://img01.yzcdn.cn/vant/apple-2.jpg',
          text: '1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息1捡漏介绍信息'
        }
      ]
    }
  },
  methods: {
    getRandomChar () {
      return Math.random().toString(36).substring(2, 4)
    },
    getRandomInt (min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    initPage () {
      for (let index = 0; index < 60; index++) {
        const tmp =
          this.getRandomChar() +
          '******' +
          this.getRandomChar() +
          '  ' +
          this.getRandomInt(1, 5) +
          '小时前捡漏到一件商品'
        this.msglst.push(tmp)
      }
    }
  },
  mounted () {
    this.initPage()
  }
}
</script>
<style lang="scss" scoped>
.discounted-main-box {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: scroll;
  .page-title {
    text-align: center;
    font-weight: bold;
    padding-top: 40px;
  }
  .page-subtitle {
    text-align: center;
    margin: 10px 0 0;
  }
  .page-data-box {
    // background-color: rgba(255, 255, 255, 0.6);
    margin: 0px 15px;
    padding: 15px 0px;
    border-radius: 12px;
    
    display: flex;
    gap: 10px;
    .col-box {
      flex: 1;
    }
  }
}
.discounted-main-box::-webkit-scrollbar {
    display: none;
  }
</style>
<style lang="scss">
.gold-shine-text {
  font-size: 32px;
  font-weight: bold;
  font-family: 'Microsoft YaHei', sans-serif;

  /* 1. 定义金色渐变背景 */
  /* 颜色建议：深金 -> 亮金/白 -> 深金，形成高光带 */
  background: linear-gradient(
    90deg,
    #b8860b 0%,
    #ffd700 25%,
    #fffacd 50%,
    #ffd700 75%,
    #b8860b 100%
  );

  /* 2. 关键属性：将背景裁剪到文字上 */
  -webkit-background-clip: text;
  background-clip: text;

  /* 3. 文字本身透明，露出背景 */
  color: transparent;

  /* 4. 扩大背景宽度，以便移动产生动画 */
  background-size: 200% auto;

  /* 5. 添加动画 */
  animation: shine 3s linear infinite;
}
@keyframes shine {
  to {
    background-position: 200% center;
  }
}

.gold-shine-text1 {
  font-size: 32px;
  font-weight: bold;
  font-family: 'Microsoft YaHei', sans-serif;

  /* 1. 定义金色渐变背景 */
  /* 颜色建议：深金 -> 亮金/白 -> 深金，形成高光带 */
  background: linear-gradient(90deg, #b8860b 0%, #ffd700 50%, #b8860b 100%);

  /* 2. 关键属性：将背景裁剪到文字上 */
  -webkit-background-clip: text;
  background-clip: text;

  /* 3. 文字本身透明，露出背景 */
  color: transparent;

  /* 4. 扩大背景宽度，以便移动产生动画 */
  background-size: 200% auto;

  /* 5. 添加动画 */
  animation: shine1 3s linear infinite;
}
@keyframes shine1 {
  to {
    background-position: 200% center;
  }
}

.gold-glow-text {
  font-size: 16px;
  font-weight: bold;
  color: #ffd700; /* 基础金色 */

  /* 初始状态：微弱光晕 */
  text-shadow: 0 0 5px #b8860b, 0 0 10px #ffd700;

  animation: glow 2s ease-in-out infinite alternate;
}

@keyframes glow {
  from {
    color: #ffd700;
    text-shadow: 0 0 5px #b8860b, 0 0 10px #ffd700;
  }
  to {
    color: #fffacd; /* 变亮，接近白色的高光金 */
    text-shadow: 0 0 20px #ffd700, 0 0 30px #ffeb3b, 0 0 40px #ffeb3b;
  }
}
.notice-swipe {
  text-align: center;
  height: 24px;
  line-height: 24px;
  width: 100%;
}

.page-noticebox {
  background: rgba(255, 255, 255, 0.8);
  position: absolute;
  top: 0px;
  z-index: 1;
  width: 100%;
  left: 0px;
  .van-notice-bar {
    background-color: transparent !important;
    color: #000 !important;
    .van-notice-bar__content {
      width: 100%;
    }
  }
}
</style>
